import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import CheckBox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import axios from "axios";
import toastr from "toastr";

class Modals extends React.Component {

  constructor(props) {
    super(props);
    this.state = {reportingManager: null, status: false, itComments: this.props.employee.itComments}
    this.applyExit = this.applyExit.bind(this);
    this.getRequestObject = this.getRequestObject.bind(this);
    this.changeStatus = this.changeStatus.bind(this);

  }

  getRequestObject(data) {
    data.id = null;
    data.empId = this.props.employee.employeeCode;
    data.name = this.props.employee.name;

    return data;
  }

  applyExit(data, recovery) {
    let request = Object.assign({}, data);
    request.recovery = recovery;
    request = this.getRequestObject(request);
    console.log(request);
    axios.post(process.env.REQ_URL + "/applyExit", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.props.close();
      this.props.refresh();
      toastr.success("Data updated")

    }).catch((err)=> {
      toastr.error("Error Occurred");

    });

  }

  changeStatus() {
    let request = new Object();
    request.id = this.props.employee.id;
    request.empId = this.props.employee.employeeCode;
    request.itComments = this.state.itComments;
    if (this.state.status == false) {
      request.status = "pending";

    }
    else
      request.status = "completed - " + this.props.user.empno + " " + this.props.user.name;
    console.log(request);
    axios.post(process.env.REQ_URL + "/exit/changeItStatus", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.props.close();
      this.props.refresh();
      toastr.success("Data updated")
    }).catch((err)=> {
      toastr.error("Error Occurred");

    });


  }

  componentWillReceiveProps(props) {
    if (props.employee.itStatus == 'pending') {
      this.setState({status: false})
    }
    else
      this.setState({status: true})
  }

  componentDidMount() {
    if (this.props.employee.itStatus == 'pending') {
      this.setState({status: false})
    }
    else
      this.setState({status: true})
  }


  render() {
    console.log(this.state.status);

    return (
      <Modal
        bsSize="small"
        show={this.props.open} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Change Status - {this.props.employee.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CheckBox
            onCheck={()=> {
              console.log(this.state.status);
              this.setState({status: !this.state.status})
            }}
            label="Completed"
            defaultChecked={this.state.status}/>
          <TextField
            hintText="Enter Remarks if any"
            floatingLabelText="Remarks"
            value={this.state.itComments}
            onChange={(event)=> {
              this.setState({itComments: event.target.value})
            }
            }/>
          <br/>
          <button
            onClick={this.changeStatus}
            className="btn btn-default btn-block">Save
          </button>
          &nbsp;
        </Modal.Body>
      </Modal>
    );
  }
}

Modals.propTypes = {};

export default Modals;





/** WEBPACK FOOTER **
 ** ./src/feature/it/Exit/ModalIt.js
 **/